import React, { Component } from "react";
import PropTypes from "prop-types";
import { Button, InputGroup, InputGroupAddon, Input } from "reactstrap";
import { CompactPicker } from "react-color";

const styles = {
  popover: {
    position: "absolute",
    zIndex: "2"
  },

  cover: {
    position: "fixed",
    top: "0px",
    right: "0px",
    bottom: "0px",
    left: "0px"
  }
};

class ColorInput extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showPicker: false
    };
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(color) {
    const event = { target: { name: this.props.name, value: color.hex } };
    this.setState({ showPicker: false });
    this.props.onChange(event);
  }

  togglePicker() {
    this.setState(state => ({ showPicker: !state.showPicker }));
  }

  render() {
    return (
      <div>
        <InputGroup>
          <Input
            type="text"
            value={this.props.value}
            onClick={() => {
              this.setState({ showPicker: true });
            }}
            readOnly
          />
          <InputGroupAddon addonType="append">
            <Button
              size="sm"
              onClick={() => {
                this.setState(state => ({
                  showPicker: !state.showPicker
                }));
              }}
              style={{ backgroundColor: this.props.value }}
            >
              {this.props.label}
            </Button>
          </InputGroupAddon>
        </InputGroup>
        {this.state.showPicker ? (
          <div style={styles.popover}>
            <div
              onClick={() => {
                this.setState({ showPicker: false });
              }}
              style={styles.cover}
            />
            <CompactPicker
              color={this.props.value}
              onChange={this.handleChange}
            />
          </div>
        ) : null}
      </div>
    );
  }
}

ColorInput.defaultProps = {
  value: null,
  label: ""
};

ColorInput.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.string,
  label: PropTypes.string,
  onChange: PropTypes.func.isRequired
};

export default ColorInput;
